import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/slambet/images/footer/logoFooter.png';

export default function index() {
  return <Image src={footerLogo} maxW="135px" />;
}
